interface GoalMilestone {
	name: string;
	milestoneTarget: string | number | null;
	startDate: Date | null;
	endDate: Date | null;
	completed?: boolean;
	isToBePublish?: boolean;
	id?: string;
}

interface ClinicalGoals {
	calorieConsumption: number | null;
	calorieConsumptionDates: Date[];
	calorieConsumptionDescription: string | null;
	proteinIntake: number | null;
	proteinIntakeDates: Date[];
	proteinIntakeDescription: string | null;
	carbohydrateIntake: number | null;
	carbohydrateIntakeDates: Date[];
	carbohydrateIntakeDescription: string | null;
	fatIntake: number | null;
	fatIntakeDates: Date[];
	fatIntakeDescription: string | null;
	mealsPerDay: number | null;
	mealsPerDayDates: Date[];
	mealsPerDayDescription: string | null;
	vo2MaxPercentile: number | null;
	vo2MaxPercentileDates: Date[];
	vo2MaxPercentileDescription: string | null;
	workoutFrequency: number | null;
	workoutFrequencyDates: Date[];
	workoutFrequencyDescription: string | null;
	metMinutes: number | null;
	metMinutesDates: Date[];
	metMinutesDescription: string | null;
	muscleQuantity: number | null;
	muscleQuantityDates: Date[];
	muscleQuantityDescription: string | null;
	muscleMass: number | null;
	muscleMassDates: Date[];
	muscleMassDescription: string | null;
	weeklyMiles: number | null;
	weeklyMilesDates: Date[];
	weeklyMilesDescription: string | null;
	bedTime: string;
	bedTimeDates: Date[];
	bedTimeDescription: string | null;
	deepSleepHours: number | null;
	deepSleepHoursDates: Date[];
	deepSleepHoursDescription: string | null;
	stepsCount: number | null;
	stepsCountDates: Date[];
	stepsCountDescription: string | null;
	activeCaloriesBurnt: number | null;
	activeCaloriesBurntDates: Date[];
	activeCaloriesBurntDescription: string | null;
	sleepDuration: number | null;
	sleepDurationDates: Date[];
	sleepDurationDescription: string | null;
	timeInRange: number | null;
	timeInRangeDates: Date[];
	timeInRangeDescription: string | null;
	timeInTightRange: number | null;
	timeInTightRangeDates: Date[];
	timeInTightRangeDescription: string | null;
	targetBMI: number | null;
	targetBMIDates: Date[];
	targetBMIDescription: string | null;
	hba1c: number | null;
	hba1cDates: Date[];
	hba1cDescription: string | null;
	hba1cDuration: number | null;
	hba1cDurationDates: Date[];
	hba1cDurationDescription: string | null;
	fastingGlucose: string;
	fastingGlucoseDates: Date[];
	fastingGlucoseDescription: string | null;
	weightToLose: number | null;
	weightToLoseDates: Date[];
	weightToLoseDescription: string | null;
	weightToLoseDuration: number | null;
	weightToLoseDurationDates: Date[];
	weightToLoseDurationDescription: string | null;
	// Score goals
	sleepScore: number | null;
	sleepScoreDates: Date[];
	sleepScoreDescription: string | null;
	readinessScore: number | null;
	readinessScoreDates: Date[];
	readinessScoreDescription: string | null;
	nutritionScore: number | null;
	nutritionScoreDates: Date[];
	nutritionScoreDescription: string | null;
	activityScore: number | null;
	activityScoreDates: Date[];
	activityScoreDescription: string | null;
	glucoseScore: number | null;
	glucoseScoreDates: Date[];
	glucoseScoreDescription: string | null;
}

import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastService } from '../../services/toast.service';
import { MemberTargetsService } from '../member-targets.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDateRangeInput } from '@angular/material/datepicker';
import { MatLabel } from '@angular/material/form-field';
import { MatHint } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { format } from 'date-fns';

@Component({
	selector: 'app-goal',
	standalone: true,
	imports: [CommonModule, FormsModule, MatDatepickerModule, MatHint, MatLabel, MatDateRangeInput,
		MatFormFieldModule, MatNativeDateModule, MatProgressSpinnerModule],
	templateUrl: './goal.component.html',
	styleUrls: ['./goal.component.css']
})

export class GoalComponent implements OnInit {
	@Input() memberId: string = '';
	subTab: string = 'Clinical';
	loading: boolean = false;
	showHistory: boolean = false;
	historyRecords: any[] = [];
	historyLoading: boolean = false;
	historyError: string = '';
	historyGoalLabel: string = '';
	historySectionTitle: string = '';
	historySectionIcon: string = '';
	historyDateRange: { start: Date | null, end: Date | null } = { start: null, end: null };
	private selectedHistoryComponent: string = '';
	calorieConsumptionDisabled: boolean = false;
	proteinIntakeDisabled: boolean = false;
	carbohydrateIntakeDisabled: boolean = false;
	fatIntakeDisabled: boolean = false;
	mealsPerDayDisabled: boolean = false;
	vo2MaxPercentileDisabled: boolean = false;
	workoutFrequencyDisabled: boolean = false;
	metMinutesDisabled: boolean = false;
	muscleQuantityDisabled: boolean = false;
	muscleMassDisabled: boolean = false;
	weeklyMilesDisabled: boolean = false;
	bedTimeDisabled: boolean = false;
	deepSleepHoursDisabled: boolean = false;
	stepsCountDisabled: boolean = false;
	activeCaloriesBurntDisabled: boolean = false;
	sleepDurationDisabled: boolean = false
	timeInRangeDisabled: boolean = false;
	timeInTightRangeDisabled: boolean = false
	targetBMIDisabled: boolean = false;
	hba1cDisabled: boolean = false
	hba1cDurationDisabled: boolean = false;
	fastingGlucoseDisabled: boolean = false
	weightToLoseDisabled: boolean = false;
	weightToLoseDurationDisabled: boolean = false;
	// Score goals disabled flags
	sleepScoreDisabled: boolean = false;
	readinessScoreDisabled: boolean = false;
	nutritionScoreDisabled: boolean = false;
	activityScoreDisabled: boolean = false;
	glucoseScoreDisabled: boolean = false;
	private currentTargets: any[] = [];
	saving: boolean = false;
	completeText: string = 'Mark Current Goal Complete';
	bedTimeOptions: string[] = [
		'08:00 PM', '08:30 PM', '09:00 PM', '09:30 PM', '10:00 PM', '10:30 PM',
		'11:00 PM', '11:30 PM', '12:00 AM', '12:30 AM', '01:00 AM'
	];
	statusOptions = [
		{ label: 'In Progress', value: 'In Progress' },
		{ label: 'Completed', value: 'Completed' }
	];
	pillarOptions = [
		{ label: 'Nutrition Pillar', value: 'nutrition' as const },
		{ label: 'Sleep Pillar', value: 'sleep' as const },
		{ label: 'Activity Pillar', value: 'activity' as const },
		{ label: 'Glucose Pillar', value: 'glucose' as const }
	];
	selectedPillar: 'nutrition' | 'sleep' | 'activity' | 'glucose' = 'nutrition';
	private goalStatuses: { [key: string]: string } = {};
	private goalMilestones: { [key: string]: GoalMilestone[] } = {};
	private goalStatusDropdownOpen: { [key: string]: boolean } = {};
	private originalStartDatesFromAPI: { [key: string]: Date | null } = {};
	goalFieldErrors: { [key: string]: { description?: boolean; value?: boolean; dates?: boolean; status?: boolean } } = {};
	milestoneFieldErrors: { [key: string]: { [index: number]: { name?: boolean; target?: boolean; dates?: boolean } } } = {};

	constructor(
		private memberTargetsService: MemberTargetsService,
		private toastr: ToastService
	) { }

	private ensureMilestoneArray(key: string): GoalMilestone[] {
		if (!this.goalMilestones[key]) {
			this.goalMilestones[key] = [];
		}
		return this.goalMilestones[key];
	}

	private applyMilestones(goalKey: string, target: any): void {
		const list = this.ensureMilestoneArray(goalKey);
		list.length = 0;
		const source: any[] = Array.isArray(target?.milestones) ? target.milestones : [];
		source.forEach((milestone: any) => {
			const targetValue = milestone?.milestoneTarget ?? milestone?.target;
			// For bedTime and fastingGlucose, keep as string; for others, convert to number
			let processedTarget: string | number | null = null;
			if (targetValue !== null && targetValue !== undefined) {
				// Check if it's a bedTime or fastingGlucose goal (both use string values)
				if (goalKey === 'bedTime' || goalKey === 'fastingGlucose' || (typeof targetValue === 'string' && (targetValue.includes(':') || targetValue.includes('-')))) {
					processedTarget = String(targetValue);
				} else {
					const numericValue = Number(targetValue);
					// Convert from calories to grams when loading (same as goal values)
					if (goalKey === 'proteinIntake' || goalKey === 'carbohydrateIntake') {
						processedTarget = numericValue / 4;
					} else if (goalKey === 'fatIntake') {
						processedTarget = numericValue / 9;
					} else {
						processedTarget = numericValue;
					}
				}
			}
			// Normalize dates when loading from API to ensure proper date handling
			let startDateNormalized: Date | null = null;
			let endDateNormalized: Date | null = null;
			
			if (milestone?.startDate) {
				startDateNormalized = new Date(milestone.startDate);
				startDateNormalized.setHours(0, 0, 0, 0);
			}
			
			if (milestone?.endDate) {
				endDateNormalized = new Date(milestone.endDate);
				endDateNormalized.setHours(0, 0, 0, 0);
			}
			
			list.push({
				name: milestone?.taskName ?? milestone?.name ?? '',
				milestoneTarget: processedTarget,
				startDate: startDateNormalized,
				endDate: endDateNormalized,
				completed: milestone?.completed ?? milestone?.isCompleted ?? false,
				isToBePublish: milestone?.isToBePublish ?? milestone?.toBePublished ?? false,
				id: milestone?.id ?? milestone?._id ?? milestone?.milestoneId
			});
		});
		// Update publish states after loading milestones from API
		this.updateMilestonePublishStates(goalKey);
	}

	private addStatusForGoal(key: string, target: any): void {
		const componentStatus = target?.status || target?.goalStatus || 'In Progress';
		this.goalStatuses[key] = componentStatus;
	}

	getClinicalGoalValue(key: any): any {
		return (this.clinicalGoals as any)[key];
	}
	setClinicalGoalValue(key: string, value: any): void {
		(this.clinicalGoals as any)[key] = value;
		// Clear value error if field is filled
		if (value !== null && value !== undefined && value !== '' && (typeof value !== 'number' || value !== 0)) {
			if (key === 'bedTime' || key === 'fastingGlucose') {
				if (value && String(value).trim() !== '') {
					if (this.goalFieldErrors[key]) {
						this.goalFieldErrors[key].value = false;
					}
				}
			} else {
				if (this.goalFieldErrors[key]) {
					this.goalFieldErrors[key].value = false;
				}
			}
		}
	}

	getClinicalGoalDescription(key: any): any {
		return (this.clinicalGoals as any)[key + 'Description'];
	}
	setClinicalGoalDescription(key: string, value: any): void {
		(this.clinicalGoals as any)[key + 'Description'] = value;
	}

	getDisabledPropAsAny(key: any): any {
		return (this as any)[key + 'Disabled'];
	}

	getDatesPropAsAny(key: any): any {
		return (this.clinicalGoals as any)[key + 'Dates'];
	}

	onGoalDateChange(key: string): void {
		// Clear dates error if both dates are filled
		const dates = this.getDatesPropAsAny(key);
		if (dates && Array.isArray(dates) && dates.length >= 2 && dates[0] && dates[1]) {
			if (this.goalFieldErrors[key]) {
				this.goalFieldErrors[key].dates = false;
			}
		}
	}
	getStatusForGoal(key: string): string {
		return this.goalStatuses[key] ?? '';
	}
	setStatusForGoal(key: string, value: string): void {
		this.goalStatuses[key] = value;
	}

	toggleGoalStatusDropdown(goalKey: string): void {
		this.goalStatusDropdownOpen[goalKey] = !this.goalStatusDropdownOpen[goalKey];
	}

	isGoalStatusDropdownOpen(goalKey: string): boolean {
		return this.goalStatusDropdownOpen[goalKey] ?? false;
	}

	areAllMilestonesCompleted(goalKey: string): boolean {
		const milestones = this.getMilestonesForGoal(goalKey);
		if (milestones.length === 0) {
			return true; // No milestones means all are "completed" (none to complete)
		}
		return milestones.every(m => m.completed === true);
	}

	selectGoalStatus(goalKey: string, status: string): void {
		// Prevent selecting "Completed" if not all milestones are completed
		if (status === 'Completed' && !this.areAllMilestonesCompleted(goalKey)) {
			return;
		}
		this.setStatusForGoal(goalKey, status);
		this.goalStatusDropdownOpen[goalKey] = false;
		// Clear status error if status is selected
		if (status && status.trim() !== '') {
			if (this.goalFieldErrors[goalKey]) {
				this.goalFieldErrors[goalKey].status = false;
			}
		}
	}


	getMilestonesForGoal(key: string): GoalMilestone[] {
		return this.ensureMilestoneArray(key);
	}

	getGoalStartDate(key: string): Date | null {
		const dates = this.getDatesPropAsAny(key);
		if (!Array.isArray(dates) || !dates[0]) return null;
		const date = new Date(dates[0]);
		date.setHours(0, 0, 0, 0);
		return date;
	}

	getGoalEndDate(key: string): Date | null {
		const dates = this.getDatesPropAsAny(key);
		if (!Array.isArray(dates) || !dates[1]) return null;
		const date = new Date(dates[1]);
		date.setHours(0, 0, 0, 0);
		return date;
	}

	getMilestoneMinDate(goalKey: string, milestoneIndex: number): Date | null {
		const goalStartDate = this.getGoalStartDate(goalKey);
		if (!goalStartDate) return null;

		const milestones = this.getMilestonesForGoal(goalKey);
		
		// If this is the first milestone, min date is goal start date
		if (milestoneIndex === 0) {
			return goalStartDate;
		}

		// Find the previous milestone's end date
		for (let i = milestoneIndex - 1; i >= 0; i--) {
			if (milestones[i] && milestones[i].endDate) {
				// Return the day after the previous milestone's end date
				const prevEndDateValue = milestones[i].endDate;
				if (prevEndDateValue) {
					const prevEndDate = new Date(prevEndDateValue);
					prevEndDate.setHours(0, 0, 0, 0);
					prevEndDate.setDate(prevEndDate.getDate() + 1);
					return prevEndDate;
				}
			}
		}

		// If no previous milestone has an end date, use goal start date
		return goalStartDate;
	}

	getMilestoneMaxDate(goalKey: string, milestoneIndex: number): Date | null {
		const goalEndDate = this.getGoalEndDate(goalKey);
		if (!goalEndDate) return null;

		const milestones = this.getMilestonesForGoal(goalKey);
		
		// If this is the last milestone, max date is goal end date
		if (milestoneIndex === milestones.length - 1) {
			return goalEndDate;
		}

		// Find the next milestone's start date
		for (let i = milestoneIndex + 1; i < milestones.length; i++) {
			if (milestones[i] && milestones[i].startDate) {
				// Return the day before the next milestone's start date
				const nextStartDateValue = milestones[i].startDate;
				if (nextStartDateValue) {
					const nextStartDate = new Date(nextStartDateValue);
					nextStartDate.setHours(0, 0, 0, 0);
					nextStartDate.setDate(nextStartDate.getDate() - 1);
					return nextStartDate;
				}
			}
		}

		// If no next milestone has a start date, use goal end date
		return goalEndDate;
	}

	onMilestoneNameChange(goalKey: string, milestoneIndex: number, value: string): void {
		// Clear name error if field is filled
		if (value && String(value).trim() !== '') {
			if (this.milestoneFieldErrors[goalKey]?.[milestoneIndex]) {
				this.milestoneFieldErrors[goalKey][milestoneIndex].name = false;
			}
		}
	}

	getMilestoneTargetValue(goalKey: string, milestoneIndex: number): string | number | null {
		const milestones = this.getMilestonesForGoal(goalKey);
		if (milestones[milestoneIndex]) {
			return milestones[milestoneIndex].milestoneTarget;
		}
		return null;
	}

	setMilestoneTargetValue(goalKey: string, milestoneIndex: number, value: any): void {
		const milestones = this.getMilestonesForGoal(goalKey);
		if (milestones[milestoneIndex]) {
			// For bedTime and fastingGlucose, keep as string
			if (goalKey === 'bedTime' || goalKey === 'fastingGlucose') {
				milestones[milestoneIndex].milestoneTarget = value !== null && value !== undefined ? String(value) : null;
			} else {
				// For numeric fields (including protein, carbs, fat), always store as number
				milestones[milestoneIndex].milestoneTarget = value !== null && value !== undefined && value !== '' ? Number(value) : null;
			}
		}
	}

	onMilestoneTargetChange(goalKey: string, milestoneIndex: number, value: any): void {
		// Update the milestone target value using setter (ensures proper type)
		this.setMilestoneTargetValue(goalKey, milestoneIndex, value);
		// Clear target error if field is filled
		if (value !== null && value !== undefined) {
			if (goalKey === 'bedTime' || goalKey === 'fastingGlucose') {
				if (String(value).trim() !== '') {
					if (this.milestoneFieldErrors[goalKey]?.[milestoneIndex]) {
						this.milestoneFieldErrors[goalKey][milestoneIndex].target = false;
					}
				}
			} else {
				if (value !== '' && Number(value) !== 0) {
					if (this.milestoneFieldErrors[goalKey]?.[milestoneIndex]) {
						this.milestoneFieldErrors[goalKey][milestoneIndex].target = false;
					}
				}
			}
		}
	}

	onMilestoneDateChange(goalKey: string, milestoneIndex: number, dateType: 'start' | 'end'): void {
		const milestones = this.getMilestonesForGoal(goalKey);
		const currentMilestone = milestones[milestoneIndex];
		
		if (!currentMilestone) return;

		// Clear dates error if both dates are filled
		if (currentMilestone.startDate && currentMilestone.endDate) {
			if (this.milestoneFieldErrors[goalKey]?.[milestoneIndex]) {
				this.milestoneFieldErrors[goalKey][milestoneIndex].dates = false;
			}
		}

		// Clear dates of all subsequent milestones when this milestone's date changes
		for (let i = milestoneIndex + 1; i < milestones.length; i++) {
			milestones[i].startDate = null;
			milestones[i].endDate = null;
		}

		// Normalize dates to midnight for comparison
		const normalizeDate = (date: Date | null): Date | null => {
			if (!date) return null;
			const normalized = new Date(date);
			normalized.setHours(0, 0, 0, 0);
			return normalized;
		};

		// Validate that start date is before end date
		if (currentMilestone.startDate && currentMilestone.endDate) {
			const startDate = normalizeDate(new Date(currentMilestone.startDate));
			const endDate = normalizeDate(new Date(currentMilestone.endDate));
			if (startDate && endDate && startDate > endDate) {
				// If start date is after end date, clear end date
				currentMilestone.endDate = null;
			}
		}

		// Validate that dates are within allowed range
		const minDate = this.getMilestoneMinDate(goalKey, milestoneIndex);
		const maxDate = this.getMilestoneMaxDate(goalKey, milestoneIndex);
		
		if (minDate && currentMilestone.startDate) {
			const normalizedMinDate = normalizeDate(minDate);
			const normalizedStartDate = normalizeDate(new Date(currentMilestone.startDate));
			if (normalizedMinDate && normalizedStartDate && normalizedStartDate < normalizedMinDate) {
				currentMilestone.startDate = null;
			}
		}
		if (maxDate && currentMilestone.endDate) {
			const normalizedMaxDate = normalizeDate(maxDate);
			const normalizedEndDate = normalizeDate(new Date(currentMilestone.endDate));
			if (normalizedMaxDate && normalizedEndDate && normalizedEndDate > normalizedMaxDate) {
				currentMilestone.endDate = null;
			}
		}
	}

	getMinStartDate(key: string): Date | null {
		// If goal is disabled (existing goal, not being edited), allow past dates
		if (this.getDisabledPropAsAny(key)) {
			return null;
		}
		
		// If goal is being edited (not disabled), check if original start date from API is in the past
		const originalStartDate = this.originalStartDatesFromAPI[key];
		if (originalStartDate) {
			const today = new Date();
			today.setHours(0, 0, 0, 0);
			const start = new Date(originalStartDate);
			start.setHours(0, 0, 0, 0);
			
			// If original start date from API is less than today, freeze all dates before the start date
			if (start < today) {
				return start;
			}
		}
		
		// For new goals or goals with future start dates, restrict to today or later
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		return today;
	}

	isStartDateDisabled(key: string): boolean {
		// Disable start date input if it's in the past and goal is being edited
		if (this.getDisabledPropAsAny(key)) {
			return false; // Goal is not being edited, so don't disable
		}
		
		// Use original start date from API response
		const originalStartDate = this.originalStartDatesFromAPI[key];
		if (originalStartDate) {
			const today = new Date();
			today.setHours(0, 0, 0, 0);
			const start = new Date(originalStartDate);
			start.setHours(0, 0, 0, 0);
			
			// If original start date from API is less than today, disable the start date input
			return start < today;
		}
		
		return false;
	}

	addMilestone(goalKey: string): void {
		const list = this.ensureMilestoneArray(goalKey);
		list.push({ name: '', milestoneTarget: null, startDate: null, endDate: null, completed: false, isToBePublish: false });
		// Update publish states after adding a new milestone
		this.updateMilestonePublishStates(goalKey);
	}

	removeMilestone(goalKey: string, index: number): void {
		const list = this.ensureMilestoneArray(goalKey);
		if (index >= 0 && index < list.length) {
			list.splice(index, 1);
			// Update publish states after removing a milestone
			this.updateMilestonePublishStates(goalKey);
		}
	}

	toggleMilestoneCompletion(goalKey: string, index: number): void {
		const list = this.ensureMilestoneArray(goalKey);
		if (index >= 0 && index < list.length) {
			const current = list[index].completed === true;
			list[index].completed = !current;
			
			// When a milestone is completed, disable its publish and enable next uncompleted milestone's publish
			if (list[index].completed) {
				list[index].isToBePublish = false;
				this.updateMilestonePublishStates(goalKey);
			} else {
				// If uncompleting, reset publish states
				this.updateMilestonePublishStates(goalKey);
			}
		}
	}

	isMilestonePublishEnabled(goalKey: string, index: number): boolean {
		const list = this.ensureMilestoneArray(goalKey);
		if (index < 0 || index >= list.length) {
			return false;
		}
		
		// Find the first uncompleted milestone index
		const firstUncompletedIndex = list.findIndex(m => !m.completed);
		
		// Only the first uncompleted milestone can have publish enabled
		// If all are completed, no milestone can have publish enabled
		return firstUncompletedIndex === index;
	}

	updateMilestonePublishStates(goalKey: string): void {
		const list = this.ensureMilestoneArray(goalKey);
		
		// Find the first uncompleted milestone
		const firstUncompletedIndex = list.findIndex(m => !m.completed);
		
		// Disable all publish buttons and set to false
		list.forEach((milestone, index) => {
			if (index === firstUncompletedIndex && firstUncompletedIndex !== -1) {
				// Enable the first uncompleted milestone's publish button (but don't auto-set to true)
				// Keep its current state
			} else {
				// Disable and set to false for all other milestones
				milestone.isToBePublish = false;
			}
		});
	}

	toggleMilestonePublish(goalKey: string, index: number): void {
		const list = this.ensureMilestoneArray(goalKey);
		if (index >= 0 && index < list.length) {
			// Only allow toggling if this milestone's publish is enabled
			if (!this.isMilestonePublishEnabled(goalKey, index)) {
				return;
			}
			
			const current = list[index].isToBePublish === true;
			list[index].isToBePublish = !current;
		}
	}

	getVisibleGoalSections(): any[] {
		return this.goalSections.filter(section => section.key === this.selectedPillar);
	}

	isScoreGoal(key: string): boolean {
		return ['sleepScore', 'readinessScore', 'nutritionScore', 'activityScore', 'glucoseScore'].includes(key);
	}

	isScoreValueExceeded(key: string): boolean {
		if (!this.isScoreGoal(key)) return false;
		const value = (this.clinicalGoals as any)[key];
		return value !== null && value !== undefined && Number(value) > 100;
	}

	isMilestoneScoreValueExceeded(key: string, index: number): boolean {
		if (!this.isScoreGoal(key)) return false;
		const milestones = this.getMilestonesForGoal(key);
		const milestone = milestones[index];
		if (!milestone || milestone.milestoneTarget === null || milestone.milestoneTarget === undefined) return false;
		return Number(milestone.milestoneTarget) > 100;
	}
	goalSections = [
		{ title: 'Horizontal Line' },
		{
			title: 'Nutrition Pillar',
			key: 'nutrition',
			icon: '/assets/img/nut.png',
			goals: [
				{
					key: 'nutritionScore',
					label: 'Nutrition Score',
					description: 'A comprehensive score measuring overall nutrition quality and dietary habits.',
					marginLeft: '56%',
					inputType: 'number',
					isScoreGoal: true
				},
				{
					key: 'calorieConsumption',
					label: 'Calories Consumption (kcal)',
					description: 'Measures how much energy you burn through exercise and activity.',
					marginLeft: '47%',
					inputType: 'number'
				},
				{
					key: 'mealsPerDay',
					label: 'Number of Meals per Day',
					description: 'Eating consistent, balanced meals throughout the day supports steady energy and glucose management.',
					marginLeft: '42%',
					inputType: 'number'
				},
				{
					key: 'carbohydrateIntake',
					label: 'Carbohydrate Intake (g)',
					description: 'Balanced carbohydrate intake fuels the body and supports stable glucose levels throughout the day.',
					marginLeft: '44%',
					inputType: 'number'
				},
				{
					key: 'proteinIntake',
					label: 'Protein Intake (g)',
					description: 'Adequate protein supports muscle repair, improves metabolism, and helps manage hunger for better glucose control.',
					marginLeft: '56%',
					inputType: 'number'
				},
				{
					key: 'fatIntake',
					label: 'Fat Intake (g)',
					description: 'Healthy fats support hormone production, nutrient absorption, and provide sustained energy for better glucose management.',
					marginLeft: '56%',
					inputType: 'number'
				}
			]
		},
		{ title: 'Horizontal Line' },
		{
			title: 'Activity Pillar',
			key: 'activity',
			icon: '/assets/img/active.png',
			goals: [
				{
					key: 'activityScore',
					label: 'Activity Score',
					description: 'A comprehensive score measuring overall physical activity and exercise performance.',
					marginLeft: '56%',
					inputType: 'number',
					isScoreGoal: true
				},
				{
					key: 'stepsCount',
					label: 'Steps Count',
					description: 'Every step counts! Regular movement improves insulin sensitivity, burns calories, and keeps your metabolism active.',
					marginLeft: '60%',
					inputType: 'number'
				},
				{
					key: 'activeCaloriesBurnt',
					label: 'Active Calories Burned (kcal)',
					description: 'Measures how much energy you burn through exercise and activity — helping you stay on track with weight and glucose goals.',
					marginLeft: '47%',
					inputType: 'number'
				},
				{
					key: 'vo2MaxPercentile',
					label: 'VO₂Max (mL/kg/min)',
					description: 'Indicates aerobic fitness compared to peers of similar age and gender.',
					marginLeft: '47%',
					inputType: 'number'
				},
				{
					key: 'workoutFrequency',
					label: 'Workout Frequency (days/week)',
					description: 'Counts how many days per week structured workouts are completed.',
					marginLeft: '35%',
					inputType: 'number'
				},
				{
					key: 'metMinutes',
					label: 'MET (Metabolic Equivalent of Task)',
					description: 'Measures the intensity of physical activities by comparing energy expenditure during activity to rest.',
					marginLeft: '39%',
					inputType: 'number'
				},
				{
					key: 'muscleQuantity',
					label: 'Muscle Quantity (%)',
					description: 'Represents lean muscle mass percentage to monitor body composition improvements.',
					marginLeft: '44%',
					inputType: 'number'
				},
				{
					key: 'muscleMass',
					label: 'Muscle Mass (lb)',
					description: 'Tracks total lean muscle mass in pounds to monitor strength and body composition improvements.',
					marginLeft: '50%',
					inputType: 'number'
				},
				{
					key: 'weeklyMiles',
					label: 'Weekly Miles (miles/week)',
					description: 'Tracks total mileage from walking, running, or similar activities each week.',
					marginLeft: '40%',
					inputType: 'number'
				},
				{
					key: 'weightToLose',
					label: 'Weight to Lose (lb)',
					description: 'Gradual and steady weight loss can significantly improve blood sugar, cholesterol, and energy levels.',
					marginLeft: '55%',
					inputType: 'number'
				},
				{
					key: 'weightToLoseDuration',
					label: 'Weight to Lose Duration (days)',
					description: 'A healthy Target BMI guides your weight journey toward balance and long-term wellness.',
					marginLeft: '45%',
					inputType: 'number'
				},
				{
					key: 'targetBMI',
					label: 'Target BMI',
					description: 'Setting a realistic timeline keeps your weight journey safe, sustainable, and motivating.',
					marginLeft: '56%',
					inputType: 'number'
				}
			]
		},
		{ title: 'Horizontal Line' },
		{
			title: 'Sleep Pillar',
			key: 'sleep',
			icon: '/assets/img/sle.png',
			goals: [
				{
					key: 'sleepScore',
					label: 'Sleep Score',
					description: 'A comprehensive score measuring overall sleep quality and patterns.',
					marginLeft: '56%',
					inputType: 'number',
					isScoreGoal: true
				},
				{
					key: 'readinessScore',
					label: 'Readiness Score',
					description: 'A score measuring how well-rested and prepared your body is for the day ahead.',
					marginLeft: '56%',
					inputType: 'number',
					isScoreGoal: true
				},
				{
					key: 'sleepDuration',
					label: 'Total Sleep Duration (hrs)',
					description: 'Quality sleep restores your body, reduces stress hormones, and supports better glucose regulation.',
					marginLeft: '50%',
					inputType: 'number'
				},
				{
					key: 'bedTime',
					label: 'Bed Time',
					description: 'Consistent bedtimes help regulate circadian rhythm and improve sleep quality.',
					marginLeft: '58%',
					inputType: 'select'
				},
				{
					key: 'deepSleepHours',
					label: 'Deep Sleep Hours',
					description: 'Deep sleep promotes recovery and hormone balance essential for overall health.',
					marginLeft: '47%',
					inputType: 'number'
				}
			]
		},
		{ title: 'Horizontal Line' },
		{
			title: 'Glucose Pillar',
			key: 'glucose',
			icon: '/assets/img/gluc.png',
			showExtraMargin: true,
			goals: [
				{
					key: 'glucoseScore',
					label: 'Glucose Score',
					description: 'A comprehensive score measuring overall glucose management and control.',
					marginLeft: '56%',
					inputType: 'number',
					isScoreGoal: true
				},
				{
					key: 'timeInRange',
					label: 'Time in Range (%)',
					description: 'Shows how often your glucose stays within your target range — the higher, the better your control.',
					marginLeft: '56%',
					inputType: 'number'
				},
				{
					key: 'timeInTightRange',
					label: 'Time in Tight Range (%)',
					description: 'Represents how often your glucose stays in an optimal zone — ideal for long-term metabolic health.',
					marginLeft: '51%',
					inputType: 'number'
				},
				{
					key: 'hba1c',
					label: 'HBA1C',
					description: 'Reflects your average glucose over 3 months — a key marker of long-term diabetes control.',
					marginLeft: '65%',
					inputType: 'number'
				},
				{
					key: 'hba1cDuration',
					label: 'HBA1C to Achieve Duration (days)',
					description: 'Reflects your average glucose over 3 months — a key marker of long-term diabetes control.',
					marginLeft: '43%',
					inputType: 'number'
				},
				{
					key: 'fastingGlucose',
					label: 'Fasting Glucose Range',
					description: 'Shows your body\'s overnight glucose regulation — a core measure of insulin sensitivity and balance.',
					marginLeft: '52%',
					inputType: 'text'
				}
			]
		}
	];

	ngOnInit() {
		if (this.memberId) {
			this.loadGoals();
		}
	}

	loadGoals() {
		if (this.loading || this.saving) {
			return;
		}
		this.loading = true;
		this.memberTargetsService.getMemberTargetsList(this.memberId).subscribe({
			next: (res) => {
				if (Array.isArray(res)) {
					this.currentTargets = res;
				this.goalStatuses = {};
				this.goalMilestones = {};
				this.originalStartDatesFromAPI = {};
				res.forEach((target: any) => {
						const c = String(target.component || '').toUpperCase();
						switch (c) {
							case 'CALORIES_NEEDED':
								this.clinicalGoals.calorieConsumption = Number(target.target);
								this.clinicalGoals.calorieConsumptionDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.calorieConsumptionDescription = target.description || null;
								this.originalStartDatesFromAPI['calorieConsumption'] = new Date(target.startDate);
								this.calorieConsumptionDisabled = true;
								this.addStatusForGoal('calorieConsumption', target);
								this.applyMilestones('calorieConsumption', target);
								break;
							case 'PROTEINS_CALORIES_NEEDED':
								this.clinicalGoals.proteinIntake = Number(target.target) / 4;
								this.clinicalGoals.proteinIntakeDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.proteinIntakeDescription = target.description || null;
								this.originalStartDatesFromAPI['proteinIntake'] = new Date(target.startDate);
								this.proteinIntakeDisabled = true;
								this.addStatusForGoal('proteinIntake', target);
								this.applyMilestones('proteinIntake', target);
								break;
							case 'CARBS_CALORIES_NEEDED':
								this.clinicalGoals.carbohydrateIntake = Number(target.target) / 4;
								this.clinicalGoals.carbohydrateIntakeDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.carbohydrateIntakeDescription = target.description || null;
								this.originalStartDatesFromAPI['carbohydrateIntake'] = new Date(target.startDate);
								this.carbohydrateIntakeDisabled = true;
								this.addStatusForGoal('carbohydrateIntake', target);
								this.applyMilestones('carbohydrateIntake', target);
								break;
							case 'FATS_CALORIES_NEEDED':
								this.clinicalGoals.fatIntake = Number(target.target) / 9;
								this.clinicalGoals.fatIntakeDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.fatIntakeDescription = target.description || null;
								this.originalStartDatesFromAPI['fatIntake'] = new Date(target.startDate);
								this.fatIntakeDisabled = true;
								this.addStatusForGoal('fatIntake', target);
								this.applyMilestones('fatIntake', target);
								break;
							case 'MEALS_PER_DAY':
								this.clinicalGoals.mealsPerDay = Number(target.target);
								this.clinicalGoals.mealsPerDayDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.mealsPerDayDescription = target.description || null;
								this.originalStartDatesFromAPI['mealsPerDay'] = new Date(target.startDate);
								this.mealsPerDayDisabled = true;
								this.addStatusForGoal('mealsPerDay', target);
								this.applyMilestones('mealsPerDay', target);
								break;
							case 'STEPS':
								this.clinicalGoals.stepsCount = Number(target.target);
								this.clinicalGoals.stepsCountDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.stepsCountDescription = target.description || null;
								this.originalStartDatesFromAPI['stepsCount'] = new Date(target.startDate);
								this.stepsCountDisabled = true;
								this.addStatusForGoal('stepsCount', target);
								this.applyMilestones('stepsCount', target);
								break;
							case 'MOVEMENT_CALORIES_BURN':
								this.clinicalGoals.activeCaloriesBurnt = Number(target.target);
								this.clinicalGoals.activeCaloriesBurntDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.activeCaloriesBurntDescription = target.description || null;
								this.originalStartDatesFromAPI['activeCaloriesBurnt'] = new Date(target.startDate);
								this.activeCaloriesBurntDisabled = true;
								this.addStatusForGoal('activeCaloriesBurnt', target);
								this.applyMilestones('activeCaloriesBurnt', target);
								break;
							case 'VO2MAX':
								this.clinicalGoals.vo2MaxPercentile = Number(target.target);
								this.clinicalGoals.vo2MaxPercentileDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.vo2MaxPercentileDescription = target.description || null;
								this.originalStartDatesFromAPI['vo2MaxPercentile'] = new Date(target.startDate);
								this.vo2MaxPercentileDisabled = true;
								this.addStatusForGoal('vo2MaxPercentile', target);
								this.applyMilestones('vo2MaxPercentile', target);
								break;
							case 'WORKOUT_FREQUENCY':
								this.clinicalGoals.workoutFrequency = Number(target.target);
								this.clinicalGoals.workoutFrequencyDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.workoutFrequencyDescription = target.description || null;
								this.originalStartDatesFromAPI['workoutFrequency'] = new Date(target.startDate);
								this.workoutFrequencyDisabled = true;
								this.addStatusForGoal('workoutFrequency', target);
								this.applyMilestones('workoutFrequency', target);
								break;
							case 'TARGET_MET':
								this.clinicalGoals.metMinutes = Number(target.target);
								this.clinicalGoals.metMinutesDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.metMinutesDescription = target.description || null;
								this.originalStartDatesFromAPI['metMinutes'] = new Date(target.startDate);
								this.metMinutesDisabled = true;
								this.addStatusForGoal('metMinutes', target);
								this.applyMilestones('metMinutes', target);
								break;
							case 'MUSCLE_QUANTITY_PERCENT':
								this.clinicalGoals.muscleQuantity = Number(target.target);
								this.clinicalGoals.muscleQuantityDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.muscleQuantityDescription = target.description || null;
								this.originalStartDatesFromAPI['muscleQuantity'] = new Date(target.startDate);
								this.muscleQuantityDisabled = true;
								this.addStatusForGoal('muscleQuantity', target);
								this.applyMilestones('muscleQuantity', target);
								break;
							case 'MUSCLE_MASS':
								this.clinicalGoals.muscleMass = Number(target.target);
								this.clinicalGoals.muscleMassDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.muscleMassDescription = target.description || null;
								this.originalStartDatesFromAPI['muscleMass'] = new Date(target.startDate);
								this.muscleMassDisabled = true;
								this.addStatusForGoal('muscleMass', target);
								this.applyMilestones('muscleMass', target);
								break;
							case 'WEEKLY_MILES':
								this.clinicalGoals.weeklyMiles = Number(target.target);
								this.clinicalGoals.weeklyMilesDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.weeklyMilesDescription = target.description || null;
								this.originalStartDatesFromAPI['weeklyMiles'] = new Date(target.startDate);
								this.weeklyMilesDisabled = true;
								this.addStatusForGoal('weeklyMiles', target);
								this.applyMilestones('weeklyMiles', target);
								break;
							case 'TOTAL_SLEEP_DURATION':
								this.clinicalGoals.sleepDuration = Number(target.target);
								this.clinicalGoals.sleepDurationDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.sleepDurationDescription = target.description || null;
								this.originalStartDatesFromAPI['sleepDuration'] = new Date(target.startDate);
								this.sleepDurationDisabled = true;
								this.addStatusForGoal('sleepDuration', target);
								this.applyMilestones('sleepDuration', target);
								break;
							case 'BED_TIME':
								this.clinicalGoals.bedTime = String(target.target);
								this.clinicalGoals.bedTimeDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.bedTimeDescription = target.description || null;
								this.originalStartDatesFromAPI['bedTime'] = new Date(target.startDate);
								this.bedTimeDisabled = true;
								this.addStatusForGoal('bedTime', target);
								this.applyMilestones('bedTime', target);
								break;
							case 'DEEP_SLEEP_HOURS':
								this.clinicalGoals.deepSleepHours = Number(target.target);
								this.clinicalGoals.deepSleepHoursDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.deepSleepHoursDescription = target.description || null;
								this.originalStartDatesFromAPI['deepSleepHours'] = new Date(target.startDate);
								this.deepSleepHoursDisabled = true;
								this.addStatusForGoal('deepSleepHours', target);
								this.applyMilestones('deepSleepHours', target);
								break;
							case 'TIME_IN_RANGE':
								this.clinicalGoals.timeInRange = Number(target.target);
								this.clinicalGoals.timeInRangeDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.timeInRangeDescription = target.description || null;
								this.originalStartDatesFromAPI['timeInRange'] = new Date(target.startDate);
								this.timeInRangeDisabled = true;
								this.addStatusForGoal('timeInRange', target);
								this.applyMilestones('timeInRange', target);
								break;
							case 'TIME_IN_TIGHT_RANGE':
								this.clinicalGoals.timeInTightRange = Number(target.target);
								this.clinicalGoals.timeInTightRangeDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.timeInTightRangeDescription = target.description || null;
								this.originalStartDatesFromAPI['timeInTightRange'] = new Date(target.startDate);
								this.timeInTightRangeDisabled = true;
								this.addStatusForGoal('timeInTightRange', target);
								this.applyMilestones('timeInTightRange', target);
								break;
							case 'TARGET_BMI':
								this.clinicalGoals.targetBMI = Number(target.target);
								this.clinicalGoals.targetBMIDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.targetBMIDescription = target.description || null;
								this.originalStartDatesFromAPI['targetBMI'] = new Date(target.startDate);
								this.targetBMIDisabled = true;
								this.addStatusForGoal('targetBMI', target);
								this.applyMilestones('targetBMI', target);
								break;
							case 'HBA1C':
								this.clinicalGoals.hba1c = Number(target.target);
								this.clinicalGoals.hba1cDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.hba1cDescription = target.description || null;
								this.originalStartDatesFromAPI['hba1c'] = new Date(target.startDate);
								this.hba1cDisabled = true;
								this.addStatusForGoal('hba1c', target);
								this.applyMilestones('hba1c', target);
								break;
							case 'HBA1C_TO_ACHIEVE_DURATION':
								this.clinicalGoals.hba1cDuration = Number(target.target);
								this.clinicalGoals.hba1cDurationDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.hba1cDurationDescription = target.description || null;
								this.originalStartDatesFromAPI['hba1cDuration'] = new Date(target.startDate);
								this.hba1cDurationDisabled = true;
								this.addStatusForGoal('hba1cDuration', target);
								this.applyMilestones('hba1cDuration', target);
								break;
							case 'FASTING_GLUCOSE':
								this.clinicalGoals.fastingGlucose = String(target.target);
								this.clinicalGoals.fastingGlucoseDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.fastingGlucoseDescription = target.description || null;
								this.originalStartDatesFromAPI['fastingGlucose'] = new Date(target.startDate);
								this.fastingGlucoseDisabled = true;
								this.addStatusForGoal('fastingGlucose', target);
								this.applyMilestones('fastingGlucose', target);
								break;
							case 'WEIGHT_TO_LOSE':
								this.clinicalGoals.weightToLose = Number(target.target);
								this.clinicalGoals.weightToLoseDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.weightToLoseDescription = target.description || null;
								this.originalStartDatesFromAPI['weightToLose'] = new Date(target.startDate);
								this.weightToLoseDisabled = true;
								this.addStatusForGoal('weightToLose', target);
								this.applyMilestones('weightToLose', target);
								break;
							case 'WEIGHT_TO_LOSE_DURATION':
								this.clinicalGoals.weightToLoseDuration = Number(target.target);
								this.clinicalGoals.weightToLoseDurationDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.weightToLoseDurationDescription = target.description || null;
								this.originalStartDatesFromAPI['weightToLoseDuration'] = new Date(target.startDate);
								this.weightToLoseDurationDisabled = true;
								this.addStatusForGoal('weightToLoseDuration', target);
								this.applyMilestones('weightToLoseDuration', target);
								break;
							case 'SLEEP_SCORE':
								this.clinicalGoals.sleepScore = Number(target.target);
								this.clinicalGoals.sleepScoreDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.sleepScoreDescription = target.description || null;
								this.originalStartDatesFromAPI['sleepScore'] = new Date(target.startDate);
								this.sleepScoreDisabled = true;
								this.addStatusForGoal('sleepScore', target);
								this.applyMilestones('sleepScore', target);
								break;
							case 'READINESS_SCORE':
								this.clinicalGoals.readinessScore = Number(target.target);
								this.clinicalGoals.readinessScoreDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.readinessScoreDescription = target.description || null;
								this.originalStartDatesFromAPI['readinessScore'] = new Date(target.startDate);
								this.readinessScoreDisabled = true;
								this.addStatusForGoal('readinessScore', target);
								this.applyMilestones('readinessScore', target);
								break;
							case 'NUTRITION_SCORE':
								this.clinicalGoals.nutritionScore = Number(target.target);
								this.clinicalGoals.nutritionScoreDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.nutritionScoreDescription = target.description || null;
								this.originalStartDatesFromAPI['nutritionScore'] = new Date(target.startDate);
								this.nutritionScoreDisabled = true;
								this.addStatusForGoal('nutritionScore', target);
								this.applyMilestones('nutritionScore', target);
								break;
							case 'ACTIVITY_SCORE':
								this.clinicalGoals.activityScore = Number(target.target);
								this.clinicalGoals.activityScoreDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.activityScoreDescription = target.description || null;
								this.originalStartDatesFromAPI['activityScore'] = new Date(target.startDate);
								this.activityScoreDisabled = true;
								this.addStatusForGoal('activityScore', target);
								this.applyMilestones('activityScore', target);
								break;
							case 'GLUCOSE_SCORE':
								this.clinicalGoals.glucoseScore = Number(target.target);
								this.clinicalGoals.glucoseScoreDates = [new Date(target.startDate), new Date(target.endDate)];
								this.clinicalGoals.glucoseScoreDescription = target.description || null;
								this.originalStartDatesFromAPI['glucoseScore'] = new Date(target.startDate);
								this.glucoseScoreDisabled = true;
								this.addStatusForGoal('glucoseScore', target);
								this.applyMilestones('glucoseScore', target);
								break;
							default:
								break;
						}
					});
				}
				this.loading = false;
			},
			error: (err) => {
				console.error('Error loading member targets:', err);
				this.toastr.errorMessage('Failed to load goals. Please try again later.');
				this.loading = false;
			}
		});
	}

	private getUnitForComponent(component: string): string {
		const unitMap: { [key: string]: string } = {
			calorieConsumption: 'kcal',
			proteinIntake: 'kcal',
			carbohydrateIntake: 'kcal',
			fatIntake: 'kcal',
			mealsPerDay: 'meals',
			stepsCount: 'steps',
			activeCaloriesBurnt: 'kcal',
			vo2MaxPercentile: 'mL/kg/min',
			workoutFrequency: 'days/week',
			metMinutes: ' ',
			muscleQuantity: '%',
			muscleMass: 'lb',
			weeklyMiles: 'miles/week',
			sleepDuration: 'hours',
			bedTime: '',
			deepSleepHours: 'hours',
			timeInRange: '%',
			timeInTightRange: '%',
			targetBMI: '',
			hba1c: '%',
			hba1cDuration: 'days',
			fastingGlucose: 'mg/dL',
			weightToLose: 'lb',
			weightToLoseDuration: 'days',
			// Score goals
			sleepScore: '',
			readinessScore: '',
			nutritionScore: '',
			activityScore: '',
			glucoseScore: ''
		};
		return unitMap[component] || '';
	}

	private getComponentName(field: string): string {
		const fieldToComponent: { [key: string]: string } = {
			calorieConsumption: 'CALORIES_NEEDED',
			proteinIntake: 'PROTEINS_CALORIES_NEEDED',
			carbohydrateIntake: 'CARBS_CALORIES_NEEDED',
			fatIntake: 'FATS_CALORIES_NEEDED',
			mealsPerDay: 'MEALS_PER_DAY',
			stepsCount: 'STEPS',
			activeCaloriesBurnt: 'MOVEMENT_CALORIES_BURN',
			vo2MaxPercentile: 'VO2MAX',
			workoutFrequency: 'WORKOUT_FREQUENCY',
			metMinutes: 'TARGET_MET',
			muscleQuantity: 'MUSCLE_QUANTITY_PERCENT',
			muscleMass: 'MUSCLE_MASS',
			weeklyMiles: 'WEEKLY_MILES',
			sleepDuration: 'TOTAL_SLEEP_DURATION',
			bedTime: 'BED_TIME',
			deepSleepHours: 'DEEP_SLEEP_HOURS',
			timeInRange: 'TIME_IN_RANGE',
			timeInTightRange: 'TIME_IN_TIGHT_RANGE',
			targetBMI: 'TARGET_BMI',
			hba1c: 'HBA1C',
			hba1cDuration: 'HBA1C_TO_ACHIEVE_DURATION',
			fastingGlucose: 'FASTING_GLUCOSE',
			weightToLose: 'WEIGHT_TO_LOSE',
			weightToLoseDuration: 'WEIGHT_TO_LOSE_DURATION',
			// Score goals
			sleepScore: 'SLEEP_SCORE',
			readinessScore: 'READINESS_SCORE',
			nutritionScore: 'NUTRITION_SCORE',
			activityScore: 'ACTIVITY_SCORE',
			glucoseScore: 'GLUCOSE_SCORE'
		};
		return fieldToComponent[field] || field.toUpperCase();
	}

	getProgressForGoal(goalKey: string): number | null {
		const componentName = this.getComponentName(goalKey);
		const target = this.currentTargets.find((t: any) => 
			String(t.component || '').toUpperCase() === componentName.toUpperCase()
		);
		
		if (target && target.progress !== undefined && target.progress !== null) {
			const progress = Number(target.progress);
			// Return null if progress is -1, otherwise return the progress value
			return progress === -1 ? null : progress;
		}
		
		return null;
	}

	clinicalGoals: ClinicalGoals = {
		calorieConsumption: null,
		calorieConsumptionDates: [],
		calorieConsumptionDescription: null,
		proteinIntake: null,
		proteinIntakeDates: [],
		proteinIntakeDescription: null,
		carbohydrateIntake: null,
		carbohydrateIntakeDates: [],
		carbohydrateIntakeDescription: null,
		fatIntake: null,
		fatIntakeDates: [],
		fatIntakeDescription: null,
		mealsPerDay: null,
		mealsPerDayDates: [],
		mealsPerDayDescription: null,
		vo2MaxPercentile: null,
		vo2MaxPercentileDates: [],
		vo2MaxPercentileDescription: null,
		workoutFrequency: null,
		workoutFrequencyDates: [],
		workoutFrequencyDescription: null,
		metMinutes: null,
		metMinutesDates: [],
		metMinutesDescription: null,
		muscleQuantity: null,
		muscleQuantityDates: [],
		muscleQuantityDescription: null,
		muscleMass: null,
		muscleMassDates: [],
		muscleMassDescription: null,
		weeklyMiles: null,
		weeklyMilesDates: [],
		weeklyMilesDescription: null,
		bedTime: '',
		bedTimeDates: [],
		bedTimeDescription: null,
		deepSleepHours: null,
		deepSleepHoursDates: [],
		deepSleepHoursDescription: null,
		stepsCount: null,
		stepsCountDates: [],
		stepsCountDescription: null,
		activeCaloriesBurnt: null,
		activeCaloriesBurntDates: [],
		activeCaloriesBurntDescription: null,
		sleepDuration: null,
		sleepDurationDates: [],
		sleepDurationDescription: null,
		timeInRange: null,
		timeInRangeDates: [],
		timeInRangeDescription: null,
		timeInTightRange: null,
		timeInTightRangeDates: [],
		timeInTightRangeDescription: null,
		targetBMI: null,
		targetBMIDates: [],
		targetBMIDescription: null,
		hba1c: null,
		hba1cDates: [],
		hba1cDescription: null,
		hba1cDuration: null,
		hba1cDurationDates: [],
		hba1cDurationDescription: null,
		fastingGlucose: '',
		fastingGlucoseDates: [],
		fastingGlucoseDescription: null,
		weightToLose: null,
		weightToLoseDates: [],
		weightToLoseDescription: null,
		weightToLoseDuration: null,
		weightToLoseDurationDates: [],
		weightToLoseDurationDescription: null,
		// Score goals
		sleepScore: null,
		sleepScoreDates: [],
		sleepScoreDescription: null,
		readinessScore: null,
		readinessScoreDates: [],
		readinessScoreDescription: null,
		nutritionScore: null,
		nutritionScoreDates: [],
		nutritionScoreDescription: null,
		activityScore: null,
		activityScoreDates: [],
		activityScoreDescription: null,
		glucoseScore: null,
		glucoseScoreDates: [],
		glucoseScoreDescription: null
	};

	private validateGoalDates(key: string): { isValid: boolean; message: string } {
		const dates = (this.clinicalGoals as any)[`${key}Dates`];
		
		if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
			return { isValid: false, message: '' };
		}
		
		const startDate = new Date(dates[0]);
		const endDate = new Date(dates[1]);
		startDate.setHours(0, 0, 0, 0);
		endDate.setHours(0, 0, 0, 0);
		
		if (startDate > endDate) {
			return { isValid: false, message: 'Start date cannot be greater than end date' };
		}
		
		const milestones = this.getMilestonesForGoal(key);
		for (const milestone of milestones) {
			if (milestone.startDate) {
				const milestoneStart = new Date(milestone.startDate);
				milestoneStart.setHours(0, 0, 0, 0);
				if (milestoneStart < startDate || milestoneStart > endDate) {
					return { isValid: false, message: 'Milestone start date must be within the goal date range' };
				}
			}
			if (milestone.endDate) {
				const milestoneEnd = new Date(milestone.endDate);
				milestoneEnd.setHours(0, 0, 0, 0);
				if (milestoneEnd < startDate || milestoneEnd > endDate) {
					return { isValid: false, message: 'Milestone end date must be within the goal date range' };
				}
			}
		}
		
		
		
		return { isValid: true, message: '' };
	}

	getValidationMessage(key: string): string {
		return this.validateGoalDates(key).message;
	}

	isSaveButtonDisabled(key: string): boolean {
		// Check all required fields
		const description = (this.clinicalGoals as any)[`${key}Description`];
		const value = (this.clinicalGoals as any)[key];
		const dates = (this.clinicalGoals as any)[`${key}Dates`];
		const status = this.getStatusForGoal(key);
		
		// Check if any required field is empty
		const isDescriptionEmpty = !description || String(description).trim() === '';
		let isValueEmpty = false;
		if (key === 'bedTime' || key === 'fastingGlucose') {
			isValueEmpty = !value || String(value).trim() === '';
		} else {
			isValueEmpty = value === null || value === undefined || value === '' || (typeof value === 'number' && value === 0);
		}
		const isDatesEmpty = !dates || !Array.isArray(dates) || dates.length < 2 || !dates[0] || !dates[1];
		const isStatusEmpty = !status || status.trim() === '';
		
		return isDescriptionEmpty || isValueEmpty || isDatesEmpty || isStatusEmpty;
	}

	hasMilestoneFieldError(goalKey: string, milestoneIndex: number, field: 'name' | 'target' | 'dates'): boolean {
		// Only show error if the field is actually empty
		const milestones = this.getMilestonesForGoal(goalKey);
		const milestone = milestones[milestoneIndex];
		if (!milestone) return false;
		
		if (field === 'name') {
			if (milestone.name && String(milestone.name).trim() !== '') {
				return false; // Field is filled, don't show error
			}
		} else if (field === 'target') {
			if (milestone.milestoneTarget !== null && milestone.milestoneTarget !== undefined) {
				if (goalKey === 'bedTime' || goalKey === 'fastingGlucose') {
					if (String(milestone.milestoneTarget).trim() !== '') {
						return false; // Field is filled, don't show error
					}
				} else {
					if (milestone.milestoneTarget !== '' && Number(milestone.milestoneTarget) !== 0) {
						return false; // Field is filled, don't show error
					}
				}
			}
		} else if (field === 'dates') {
			if (milestone.startDate && milestone.endDate) {
				return false; // Field is filled, don't show error
			}
		}
		// Show error only if field is empty AND error was set (user tried to save)
		return this.milestoneFieldErrors[goalKey]?.[milestoneIndex]?.[field] === true;
	}

	hasFieldError(key: string, field: 'description' | 'value' | 'dates' | 'status'): boolean {
		// Only show error if the field is actually empty
		if (field === 'description') {
			const description = (this.clinicalGoals as any)[`${key}Description`];
			if (description && String(description).trim() !== '') {
				return false; // Field is filled, don't show error
			}
		} else if (field === 'value') {
			const value = (this.clinicalGoals as any)[key];
			if (key === 'bedTime' || key === 'fastingGlucose') {
				if (value && String(value).trim() !== '') {
					return false; // Field is filled, don't show error
				}
			} else {
				if (value !== null && value !== undefined && value !== '' && (typeof value !== 'number' || value !== 0)) {
					return false; // Field is filled, don't show error
				}
			}
		} else if (field === 'dates') {
			const dates = (this.clinicalGoals as any)[`${key}Dates`];
			if (dates && Array.isArray(dates) && dates.length >= 2 && dates[0] && dates[1]) {
				return false; // Field is filled, don't show error
			}
		} else if (field === 'status') {
			const status = this.getStatusForGoal(key);
			if (status && status.trim() !== '') {
				return false; // Field is filled, don't show error
			}
		}
		// Show error only if field is empty AND error was set (user tried to save)
		return this.goalFieldErrors[key]?.[field] === true;
	}

	validateGoalFields(key: string): { isValid: boolean; errors: { description?: boolean; value?: boolean; dates?: boolean; status?: boolean } } {
		const errors: { description?: boolean; value?: boolean; dates?: boolean; status?: boolean } = {};
		
		const description = (this.clinicalGoals as any)[`${key}Description`];
		const value = (this.clinicalGoals as any)[key];
		const dates = (this.clinicalGoals as any)[`${key}Dates`];
		const status = this.getStatusForGoal(key);
		
		// Validate description
		if (!description || String(description).trim() === '') {
			errors.description = true;
		}
		
		// Validate value (skip for bedTime and fastingGlucose as they have different validation)
		if (key !== 'bedTime' && key !== 'fastingGlucose') {
			if (value === null || value === undefined || value === '' || (typeof value === 'number' && value === 0)) {
				errors.value = true;
			}
		} else if (key === 'bedTime') {
			if (!value || String(value).trim() === '') {
				errors.value = true;
			}
		} else if (key === 'fastingGlucose') {
			if (!value || String(value).trim() === '') {
				errors.value = true;
			}
		}
		
		// Validate dates
		if (!dates || !Array.isArray(dates) || dates.length < 2 || !dates[0] || !dates[1]) {
			errors.dates = true;
		}
		
		// Validate status
		if (!status || status.trim() === '') {
			errors.status = true;
		}
		
		this.goalFieldErrors[key] = errors;
		
		return {
			isValid: Object.keys(errors).length === 0,
			errors
		};
	}

	handleSave(key: any) {
		// Validate all required fields and set error states
		const validation = this.validateGoalFields(key);
		if (!validation.isValid) {
			// Show error message for first missing field
			if (validation.errors.description) {
				this.toastr.errorMessage('Please enter a goal description');
			} else if (validation.errors.value) {
				this.toastr.errorMessage('Please enter a valid target value');
			} else if (validation.errors.dates) {
			this.toastr.errorMessage('Please select both start and end dates');
			} else if (validation.errors.status) {
				this.toastr.errorMessage('Please select a goal status');
			}
			return;
		}
		
		// Validate score goals: value must be <= 100
		if (this.isScoreGoal(key)) {
			const goalValue = (this.clinicalGoals as any)[key];
			if (goalValue !== null && goalValue !== undefined && Number(goalValue) > 100) {
				this.toastr.errorMessage('Score value must be less than or equal to 100');
				return;
			}
		}
		
		// Validate milestones
		const goalMilestones = this.getMilestonesForGoal(key);
		let hasMilestoneErrors = false;
		const milestoneErrors: { [index: number]: { name?: boolean; target?: boolean; dates?: boolean } } = {};
		const errorMessages: string[] = [];
		
		for (let i = 0; i < goalMilestones.length; i++) {
			const milestone = goalMilestones[i];
			const errors: { name?: boolean; target?: boolean; dates?: boolean } = {};
			const milestoneErrorsList: string[] = [];
			
			// Validate milestone name
			if (!milestone.name || String(milestone.name).trim() === '') {
				errors.name = true;
				hasMilestoneErrors = true;
				milestoneErrorsList.push('task name');
			}
			
			// Validate milestone target
			if (key === 'bedTime' || key === 'fastingGlucose') {
				// For string-based goals, check if value is null, undefined, or empty string
				const targetValue = milestone.milestoneTarget;
				if (targetValue === null || targetValue === undefined || targetValue === '' || (typeof targetValue === 'string' && targetValue.trim() === '')) {
					errors.target = true;
					hasMilestoneErrors = true;
					milestoneErrorsList.push('target value');
				}
			} else {
				// For numeric goals, check if value is null, undefined, empty string, or zero
				if (milestone.milestoneTarget === null || milestone.milestoneTarget === undefined || milestone.milestoneTarget === '' || Number(milestone.milestoneTarget) === 0) {
					errors.target = true;
					hasMilestoneErrors = true;
					milestoneErrorsList.push('target value');
				}
				
				// Validate score goal milestone values: must be <= 100
				if (this.isScoreGoal(key) && milestone.milestoneTarget !== null && milestone.milestoneTarget !== undefined && Number(milestone.milestoneTarget) > 100) {
					errors.target = true;
					hasMilestoneErrors = true;
					const milestoneNumber = i + 1;
					errorMessages.push(`Milestone ${milestoneNumber}: Score value must be less than or equal to 100`);
				}
			}
			
			// Validate milestone dates
			if (!milestone.startDate || !milestone.endDate) {
				errors.dates = true;
				hasMilestoneErrors = true;
				milestoneErrorsList.push('dates');
			}
			
			if (Object.keys(errors).length > 0) {
				milestoneErrors[i] = errors;
				const milestoneNumber = i + 1;
				if (milestoneErrorsList.length > 0) {
					errorMessages.push(`Milestone ${milestoneNumber}: Please fill ${milestoneErrorsList.join(', ')}`);
				}
			}
		}
		
		if (hasMilestoneErrors) {
			this.milestoneFieldErrors[key] = milestoneErrors;
			// Show specific error messages for each milestone
			if (errorMessages.length > 0) {
				this.toastr.errorMessage(errorMessages.join(' | '));
			}
			return;
		}
		
		// Clear errors if validation passes
		this.goalFieldErrors[key] = {};
		this.milestoneFieldErrors[key] = {};
		
		let dates = (this.clinicalGoals as any)[`${key}Dates`];
		let val = (this.clinicalGoals as any)[key];
		
		// Check if start date > end date
		const startDate = new Date(dates[0]);
		const endDate = new Date(dates[1]);
		if (startDate > endDate) {
			this.toastr.errorMessage('Start date cannot be greater than end date');
			return;
		}
		
		// Check if milestone dates are within goal date range
		const goalMilestonesForValidation = this.getMilestonesForGoal(key);
		// Normalize goal dates once before loop to avoid mutation issues
		const normalizedGoalStart = new Date(startDate);
		normalizedGoalStart.setHours(0, 0, 0, 0);
		const normalizedGoalEnd = new Date(endDate);
		normalizedGoalEnd.setHours(0, 0, 0, 0);
		
		for (const milestone of goalMilestonesForValidation) {
			if (milestone.startDate) {
				const milestoneStart = new Date(milestone.startDate);
				milestoneStart.setHours(0, 0, 0, 0);
				
				if (milestoneStart < normalizedGoalStart || milestoneStart > normalizedGoalEnd) {
					this.toastr.errorMessage('Milestone start date must be within the goal date range');
					return;
				}
			}
			if (milestone.endDate) {
				const milestoneEnd = new Date(milestone.endDate);
				milestoneEnd.setHours(0, 0, 0, 0);
				
				if (milestoneEnd < normalizedGoalStart || milestoneEnd > normalizedGoalEnd) {
					this.toastr.errorMessage('Milestone end date must be within the goal date range');
					return;
				}
			}
		}
		
		if (val === null || val === undefined || val === 0 || val === '' || Number(val) < 1) {
			this.toastr.errorMessage('Please enter a valid target value');
			return;
		}
		if (key === 'fastingGlucose') {
			const fgPattern = /^\d{2,3}-\d{2,3}$/;
			if (!fgPattern.test(val)) {
				this.toastr.errorMessage('Please enter a valid fasting glucose range (e.g., "80-120")');
				return;
			}
		}
		
		// Check if end date is greater than today and status is "Completed"
		const status = this.getStatusForGoal(key);
		if (status === 'Completed') {
			const normalizedEndDate = new Date(endDate);
			normalizedEndDate.setHours(0, 0, 0, 0);
			const today = new Date();
			today.setHours(0, 0, 0, 0);
			if (normalizedEndDate > today) {
				this.toastr.errorMessage('Please change the end date of goal to today before completing the goal because it will cause overlapping problem');
				return;
			}
		}
		
		this.onSaveGoals(key);
	}

	markComplete(key: any) {
		this.setStatusForGoal(key, 'Completed');
	}

	onSaveGoals(key: any) {
		if (this.saving) {
			return;
		}
		const goalTypes = [
			{ key: 'calorieConsumption', component: this.getComponentName('calorieConsumption'), unit: this.getUnitForComponent('calorieConsumption') },
			{ key: 'proteinIntake', component: this.getComponentName('proteinIntake'), unit: this.getUnitForComponent('proteinIntake') },
			{ key: 'carbohydrateIntake', component: this.getComponentName('carbohydrateIntake'), unit: this.getUnitForComponent('carbohydrateIntake') },
			{ key: 'fatIntake', component: this.getComponentName('fatIntake'), unit: this.getUnitForComponent('fatIntake') },
			{ key: 'mealsPerDay', component: this.getComponentName('mealsPerDay'), unit: this.getUnitForComponent('mealsPerDay') },
			{ key: 'stepsCount', component: this.getComponentName('stepsCount'), unit: this.getUnitForComponent('stepsCount') },
			{ key: 'activeCaloriesBurnt', component: this.getComponentName('activeCaloriesBurnt'), unit: this.getUnitForComponent('activeCaloriesBurnt') },
			{ key: 'vo2MaxPercentile', component: this.getComponentName('vo2MaxPercentile'), unit: this.getUnitForComponent('vo2MaxPercentile') },
			{ key: 'workoutFrequency', component: this.getComponentName('workoutFrequency'), unit: this.getUnitForComponent('workoutFrequency') },
			{ key: 'metMinutes', component: this.getComponentName('metMinutes'), unit: this.getUnitForComponent('metMinutes') },
			{ key: 'muscleQuantity', component: this.getComponentName('muscleQuantity'), unit: this.getUnitForComponent('muscleQuantity') },
			{ key: 'muscleMass', component: this.getComponentName('muscleMass'), unit: this.getUnitForComponent('muscleMass') },
			{ key: 'weeklyMiles', component: this.getComponentName('weeklyMiles'), unit: this.getUnitForComponent('weeklyMiles') },
			{ key: 'sleepDuration', component: this.getComponentName('sleepDuration'), unit: this.getUnitForComponent('sleepDuration') },
			{ key: 'bedTime', component: this.getComponentName('bedTime'), unit: this.getUnitForComponent('bedTime') },
			{ key: 'deepSleepHours', component: this.getComponentName('deepSleepHours'), unit: this.getUnitForComponent('deepSleepHours') },
			{ key: 'timeInRange', component: this.getComponentName('timeInRange'), unit: this.getUnitForComponent('timeInRange') },
			{ key: 'timeInTightRange', component: this.getComponentName('timeInTightRange'), unit: this.getUnitForComponent('timeInTightRange') },
			{ key: 'targetBMI', component: this.getComponentName('targetBMI'), unit: this.getUnitForComponent('targetBMI') },
			{ key: 'hba1c', component: this.getComponentName('hba1c'), unit: this.getUnitForComponent('hba1c') },
			{ key: 'hba1cDuration', component: this.getComponentName('hba1cDuration'), unit: this.getUnitForComponent('hba1cDuration') },
			{ key: 'fastingGlucose', component: this.getComponentName('fastingGlucose'), unit: this.getUnitForComponent('fastingGlucose') },
			{ key: 'weightToLose', component: this.getComponentName('weightToLose'), unit: this.getUnitForComponent('weightToLose') },
			{ key: 'weightToLoseDuration', component: this.getComponentName('weightToLoseDuration'), unit: this.getUnitForComponent('weightToLoseDuration') },
			// Score goals
			{ key: 'sleepScore', component: this.getComponentName('sleepScore'), unit: this.getUnitForComponent('sleepScore') },
			{ key: 'readinessScore', component: this.getComponentName('readinessScore'), unit: this.getUnitForComponent('readinessScore') },
			{ key: 'nutritionScore', component: this.getComponentName('nutritionScore'), unit: this.getUnitForComponent('nutritionScore') },
			{ key: 'activityScore', component: this.getComponentName('activityScore'), unit: this.getUnitForComponent('activityScore') },
			{ key: 'glucoseScore', component: this.getComponentName('glucoseScore'), unit: this.getUnitForComponent('glucoseScore') }
		];
		// const batchPayload = goalTypes.map(gt => ({
		// 			component: gt.component,
		// 			target:  gt.key === "proteinIntake" ? (this.clinicalGoals.proteinIntake * 4).toString() : (this.clinicalGoals as any)[gt.key]?.toString(),
		// 			unit: gt.unit,
		// 			startDate: (this.clinicalGoals as any)[`${gt.key}Dates`][0] ? format(new Date((this.clinicalGoals as any)[`${gt.key}Dates`][0]), 'yyyy-MM-dd') : null,
		// 			endDate:  (this.clinicalGoals as any)[`${gt.key}Dates`][1] ? format(new Date((this.clinicalGoals as any)[`${gt.key}Dates`][1]), 'yyyy-MM-dd') : null
		// 		}));
		const payloadItem = goalTypes.find(g => g.key === key);
		if (!payloadItem) {
			this.toastr.errorMessage('Invalid goal type');
			return;
		}
		let targetValue = (this.clinicalGoals as any)[payloadItem.key];
		const targetDates = (this.clinicalGoals as any)[`${payloadItem.key}Dates`];
		if (key === "proteinIntake" || key === "carbohydrateIntake") {
			targetValue = targetValue * 4;
		}
		if (key === "fatIntake") {
			targetValue = targetValue * 9;
		}
		const statusValue = this.getStatusForGoal(payloadItem.key) || 'In Progress';
		const existingEntry = this.currentTargets.find((t: any) => String(t.component || '').toUpperCase() === String(payloadItem.component).toUpperCase());
		const previousStatusValue = existingEntry ? String(existingEntry.status ?? existingEntry.goalStatus ?? 'In Progress') : 'In Progress';
		const milestonePayload = this.getMilestonesForGoal(payloadItem.key)
			.map(m => {
				// Normalize dates to ensure proper formatting
				let startDateFormatted: string | null = null;
				let endDateFormatted: string | null = null;
				
				if (m.startDate) {
					const startDate = new Date(m.startDate);
					startDate.setHours(0, 0, 0, 0);
					startDateFormatted = format(startDate, 'yyyy-MM-dd');
				}
				
				if (m.endDate) {
					const endDate = new Date(m.endDate);
					endDate.setHours(0, 0, 0, 0);
					endDateFormatted = format(endDate, 'yyyy-MM-dd');
				}
				
				// Convert milestoneTarget from grams to calories when saving (same as goal values)
				let milestoneTargetValue: string | null = null;
				if (m.milestoneTarget !== null && m.milestoneTarget !== undefined) {
					// For bedTime and fastingGlucose, keep as string
					if (payloadItem.key === 'bedTime' || payloadItem.key === 'fastingGlucose' || 
						(typeof m.milestoneTarget === 'string' && (String(m.milestoneTarget).includes(':') || String(m.milestoneTarget).includes('-')))) {
						milestoneTargetValue = String(m.milestoneTarget);
					} else {
						const numericValue = Number(m.milestoneTarget);
						// Convert from grams to calories when saving
						if (payloadItem.key === 'proteinIntake' || payloadItem.key === 'carbohydrateIntake') {
							milestoneTargetValue = String(numericValue * 4);
						} else if (payloadItem.key === 'fatIntake') {
							milestoneTargetValue = String(numericValue * 9);
						} else {
							milestoneTargetValue = String(numericValue);
						}
					}
				}
				
				return {
				taskName: m.name,
					milestoneTarget: milestoneTargetValue,
					startDate: startDateFormatted,
					endDate: endDateFormatted,
				completed: m.completed ?? false,
				isToBePublish: m.isToBePublish ?? false
				};
			})
			.filter(m => (m.taskName && m.taskName.trim().length > 0) || m.startDate || m.endDate);
		const goalDescription = (this.clinicalGoals as any)[`${payloadItem.key}Description`] || null;
		const batchPayload = [{
			component: payloadItem.component,
			target: targetValue.toString(),
			unit: payloadItem.unit,
			startDate: format(new Date(targetDates[0]), 'yyyy-MM-dd'),
			endDate: format(new Date(targetDates[1]), 'yyyy-MM-dd'),
			status: statusValue,
			description: goalDescription,
			milestones: milestonePayload
		}];
		const changedPayload = batchPayload.filter(p => {
			const existing = this.currentTargets.find((t: any) => String(t.component || '').toUpperCase() === String(p.component).toUpperCase());
			if (!existing) {
				if (p.target === '' || p.target === '0') {
					return false;
				}
				return true;
			}
			const existingTarget = String(existing.target ?? '');
			const existingUnit = String(existing.unit ?? '');
			const existingStartDate = (existing.startDate ? format(new Date(existing.startDate), 'yyyy-MM-dd') : null);
			const existingEndDate = (existing.endDate ? format(new Date(existing.endDate), 'yyyy-MM-dd') : null);
			const existingStatus = String(existing.status ?? existing.goalStatus ?? 'In Progress');
			const existingDescription = String(existing.description ?? existing.goalDescription ?? '');
			const normalizeMilestones = (list: any[]) => (list || []).map((milestone: any) => ({
				taskName: (milestone?.taskName ?? milestone?.name ?? '').trim(),
				milestoneTarget: (milestone?.milestoneTarget ?? milestone?.target) !== null && (milestone?.milestoneTarget ?? milestone?.target) !== undefined ? String(milestone?.milestoneTarget ?? milestone?.target) : null,
				startDate: milestone?.startDate ? format(new Date(milestone.startDate), 'yyyy-MM-dd') : null,
				endDate: milestone?.endDate ? format(new Date(milestone.endDate), 'yyyy-MM-dd') : null,
				completed: !!(milestone?.completed ?? milestone?.isCompleted),
				isToBePublish: !!(milestone?.isToBePublish ?? milestone?.toBePublished)
			}));
			const newMilestonesComparable = JSON.stringify(normalizeMilestones(p.milestones));
			const existingMilestonesComparable = JSON.stringify(normalizeMilestones(Array.isArray(existing?.milestones) ? existing.milestones : []));
			const newDescription = String(p.description ?? '');
			return existingTarget !== p.target || existingUnit !== p.unit || existingStartDate !== p.startDate || existingEndDate !== p.endDate || existingStatus !== p.status || existingDescription !== newDescription || existingMilestonesComparable !== newMilestonesComparable;
		});

		if (changedPayload.length === 0) {
			this.toastr.infoMessage('No changes to save');
			(this as any)[key + 'Disabled'] = true;
			return;
		}
		this.saving = true;
		this.memberTargetsService.saveMemberTargetsBatchByMember({
			memberId: this.memberId,
			targets: changedPayload
		}).subscribe({
			next: (_res) => {
				var errs = (_res as any)?.errors;
				if (errs.length > 0) {
					this.toastr.errorMessage('Failed to save some goals. Please try again later.');
					this.saving = false;
				} else if (statusValue === 'Completed') {
					this.finalizeGoalCompletion(payloadItem.key, payloadItem.component, previousStatusValue);
				} else {
					this.saving = false;
					this.loadGoals();
					this.toastr.successMessage('Goals saved!');
				}
			},
			error: async (_err) => {
				this.toastr.errorMessage('Failed to save goals');
				this.saving = false;
			}
		});
	}

	private finalizeGoalCompletion(key: string, component: string, previousStatus: string): void {
		this.memberTargetsService.markTargetAsComplete(this.memberId, component, 'Completed').subscribe({
			next: (_res) => {
				this.saving = false;
				if (_res && (_res as any).isUpdated) {
					this.toastr.successMessage('Goal marked as complete!');
					// Clear goal value
					if (key === 'fastingGlucose' || key === 'bedTime') {
						(this.clinicalGoals as any)[key] = '';
					} else {
						(this.clinicalGoals as any)[key] = null;
					}
					// Clear goal dates
					(this.clinicalGoals as any)[`${key}Dates`] = [];
					// Clear goal description
					(this.clinicalGoals as any)[`${key}Description`] = null;
					// Clear all milestone values and task names
					const milestones = this.getMilestonesForGoal(key);
					milestones.forEach(milestone => {
						milestone.milestoneTarget = null;
						milestone.name = '';
						milestone.startDate = null;
						milestone.endDate = null;
					});
					(this as any)[key + 'Disabled'] = false;
					this.goalStatuses[key] = 'Completed';
					this.loadGoals();
				} else {
					this.toastr.errorMessage('Failed to mark goal as complete.');
					this.goalStatuses[key] = previousStatus;
				}
			},
			error: (err) => {
				this.saving = false;
				console.error('Error marking goal complete:', err);
				this.toastr.errorMessage('Failed to mark goal as complete. Please try again later.');
				this.goalStatuses[key] = previousStatus;
			}
		});
	}

	handleEdit(btn: any) {
		(this as any)[btn + 'Disabled'] = false;
	}

	viewGoalHistory(goal: any, section: any) {
		if (!goal) {
			return;
		}
		const component = this.getComponentName(goal.key);
		this.selectedHistoryComponent = component;
		this.historyGoalLabel = goal.label || 'Goal History';
		this.historySectionTitle = section?.title || '';
		this.historySectionIcon = section?.icon || '';
		this.showHistory = true;
		this.historyLoading = false;
		this.historyError = 'Please select the date range';
		this.historyRecords = [];
		this.historyDateRange = { start: null, end: null };
	}

	closeHistoryView() {
		this.showHistory = false;
		this.historyRecords = [];
		this.selectedHistoryComponent = '';
		this.historyGoalLabel = '';
		this.historySectionIcon = '';
		this.historySectionTitle = '';
		this.historyError = '';
		this.historyDateRange = { start: null, end: null };
	}

	onHistoryStartChange() {
		if (!this.historyDateRange.start) {
			this.historyError = 'Please select the date range';
			this.historyRecords = [];
			this.historyLoading = false;
			return;
		}
		// reset end date when start changes to avoid using stale value
		this.historyDateRange.end = this.historyDateRange.end || null;
		this.historyError = 'Please select the date range';
		this.historyRecords = [];
		this.historyLoading = false;
	}

	onHistoryEndChange() {
		if (!this.historyDateRange.start || !this.historyDateRange.end) {
			this.historyError = 'Please select the date range';
			this.historyRecords = [];
			return;
		}
		if (!this.selectedHistoryComponent) {
			this.historyError = 'Invalid goal selection.';
			return;
		}
		const startDate = format(this.historyDateRange.start, 'yyyy-MM-dd');
		const endDate = format(this.historyDateRange.end, 'yyyy-MM-dd');
		this.fetchHistoryRecords(startDate, endDate);
	}

	private fetchHistoryRecords(startDate: string, endDate: string): void {
		if (!this.memberId || !this.selectedHistoryComponent) {
			this.historyError = 'Unable to load history for this goal.';
			return;
		}
		this.historyLoading = true;
		this.historyError = '';
		this.historyRecords = [];
		this.memberTargetsService.getTargetsHist(this.memberId, this.selectedHistoryComponent, startDate, endDate).subscribe({
			next: (res) => {
				this.historyLoading = false;
				if (Array.isArray(res)) {
					this.historyRecords = res.map((target: any) => ({
						...target,
						milestones: Array.isArray(target?.milestones) ? target.milestones : []
					}));
					if (this.historyRecords.length === 0) {
						this.historyError = 'No history available for this goal yet.';
					}
				} else {
					this.historyError = 'No history data available.';
				}
			},
			error: (err) => {
				console.error('Error loading goal history:', err);
				this.historyLoading = false;
				this.historyError = 'Failed to load history. Please try again later.';
			}
		});
	}

	formatHistoryTarget(record: any): string {
		if (!record) {
			return '--';
		}
		const component = String(record.component || '').toUpperCase();
		const rawTarget = record.target ?? '';
		if (rawTarget === null || rawTarget === undefined || rawTarget === '') {
			return '--';
		}
		if (component === 'PROTEINS_CALORIES_NEEDED' || component === 'CARBS_CALORIES_NEEDED') {
			const numeric = Number(rawTarget);
			if (!isNaN(numeric)) {
				return `${numeric / 4} g`;
			}
		}
		if (component === 'FATS_CALORIES_NEEDED') {
			const numeric = Number(rawTarget);
			if (!isNaN(numeric)) {
				return `${numeric / 9} g`;
			}
		}
		return record.unit ? `${rawTarget} ${record.unit}` : `${rawTarget}`;
	}

	getHistoryDateRange(record: any): string {
		if (!record) {
			return '--';
		}
		const start = this.formatDisplayDate(record.startDate || record.fromDate);
		const end = this.formatDisplayDate(record.endDate || record.toDate);
		return `${start} - ${end}`;
	}

	getHistoryCompletedDate(record: any): string {
		if (!record?.completionDateTime || record.completionDateTime === '0001-01-01T00:00:00') {
			return '---';
		}
		return this.formatDisplayDate(record.completionDateTime);
	}

	getHistoryStatus(record: any): string {
		return record?.status || record?.goalStatus || '---';
	}

	formatMilestoneDateRange(milestone: any): string {
		if (!milestone) {
			return '--';
		}
		return `${this.formatDisplayDate(milestone.startDate)} - ${this.formatDisplayDate(milestone.endDate)}`;
	}

	formatHistoryMilestoneTarget(milestone: any, record: any): string {
		if (!milestone) {
			return '--';
		}
		const component = String(record?.component || '').toUpperCase();
		const rawTarget = milestone.milestoneTarget ?? milestone.target ?? '';
		if (rawTarget === null || rawTarget === undefined || rawTarget === '') {
			return '--';
		}
		// Convert protein and carbs from kcal to grams (divide by 4)
		if (component === 'PROTEINS_CALORIES_NEEDED' || component === 'CARBS_CALORIES_NEEDED') {
			const numeric = Number(rawTarget);
			if (!isNaN(numeric)) {
				return `${numeric / 4} g`;
			}
		}
		// Convert fats from kcal to grams (divide by 9)
		if (component === 'FATS_CALORIES_NEEDED') {
			const numeric = Number(rawTarget);
			if (!isNaN(numeric)) {
				return `${numeric / 9} g`;
			}
		}
		// For other goals, return as is
		return String(rawTarget);
	}

	formatBoolean(value: any): string {
		return value ? 'Yes' : 'No';
	}

	private formatDisplayDate(dateValue: any): string {
		if (!dateValue) {
			return '--';
		}
		const parsed = new Date(dateValue);
		if (isNaN(parsed.getTime())) {
			return '--';
		}
		return format(parsed, 'MMMM d, yyyy');
	}
}
